import React from 'react'
import PropTypes from 'prop-types';
import './OrderStep.css';
import Icon from '../Icon';


/**
 * A simple OrderStep
 */

const OrderStep = ({ number, label, active, clickable, highlighted, link, action }) => {
    
    return (<div onClick={() => action(clickable, link)} className={`orderstep${active===true?" active":""}${clickable===true?" clickable":""}${highlighted===true?" highlighted":""}`}>
              <div className="number">{number}</div>
              <div className="label">{label}</div>
              <div className="next">
                <Icon filename="step_arrow" color="#cccccc" />
              </div>
          </div>)
}

OrderStep.propTypes = {
  /** actual number of OrderStep */
  number: PropTypes.number.isRequired,
  /** label of displayed OrderStep */
  label: PropTypes.string,
  /** link of displayed OrderStep */
  link: PropTypes.string,
  /** active state */
  active: PropTypes.bool,
  /** clickable state */
  clickable: PropTypes.bool,
  /** highlighted state */
  highlighted: PropTypes.bool
}

OrderStep.defaultProps = {
  label: '',
  link: '',
  active: false,
  highlighted: false,
  clickable: false
};

export default OrderStep;



// WEBPACK FOOTER //
// ./src/components/atoms/OrderStep/OrderStep.js